(ns common.db.effects.router
  (:require [common.router :refer [router]]
            [goog.Uri]
            [goog.Uri.QueryData]
            [re-frame.core :as rf]
            [reitit.frontend :as r.fe]
            [reitit.frontend.easy :as r.easy]
            [reitit.frontend.history :as r.history]))

(defn navigate!
  [[route {:keys [params query fragment]}]]
  (r.easy/push-state route params query (some-> fragment name)))

(defn replace!
  [[route {:keys [params query fragment]}]]
  (r.easy/replace-state route params query (some-> fragment name)))

(rf/reg-fx :router/replace!
  (fn [params]
    (cond
      (vector? params) (replace! params)
      (string? params) (let [match (r.fe/match-by-path router params)]
                         (replace! [(get-in match [:data :name])
                                    {:params (get-in match [:parameters :path])
                                     :query (get-in match [:parameters :query])}]))
      (keyword? params) (replace! [params {}]))))

(rf/reg-fx
  :router/navigate!
  (fn [params]
    (cond
      (vector? params) (navigate! params)
      (string? params) (let [match (r.fe/match-by-path router params)]
                         (navigate! [(get-in match [:data :name])
                                     {:params (get-in match [:parameters :path])
                                      :query (get-in match [:parameters :query])}]))
      (keyword? params) (navigate! [params {}]))))

(rf/reg-fx :router/assign
  (fn [url]
    (js/window.location.assign url)))

(rf/reg-fx :router/open-in-tab
  (fn [url]
    (js/window.open url "_blank")))

(defn update-query
  "Takes the current location and updates the query params
  with given fn and arguments."
  [f & args]
  ;; NOTE: This should be added to reitit-frontend
  (let [current (r.history/-get-path @r.easy/history)
        ^goog.Uri uri (goog.Uri/parse current)
        new-query (apply f (r.fe/query-params uri) args)
        _ (.setQueryData uri (goog.Uri.QueryData/createFromMap (clj->js new-query)))
        new-path (r.history/-href @r.easy/history (.toString uri))]
    (.pushState js/window.history nil "" new-path)
    (r.history/-on-navigate @r.easy/history new-path)))

(rf/reg-fx :router/update-query
  (fn [fn-or-args]
    (if (fn? fn-or-args)
      (update-query fn-or-args)
      (apply update-query fn-or-args))))
